/**
 * Create questionnaires for cgs, dhi, and pcs because the JSONs are currently subsections
 */

import CgsJson from 'data/cgs.json';
import dhiJson from 'data/dizziness-handicap-scale.json';
import pcsJson from 'data/pcs.json';
import promisJson from 'data/promis.json';
import {
  QuestionnaireConfig,
  questionnaireConfigSchema
} from 'data/questionnaire-config-type';
import { resolveError } from 'lib/utils/formatters/error/resolve-error';

function parseQuestionnaireConfigSchema(
  questionnaireName: string,
  config: QuestionnaireConfig
) {
  try {
    return questionnaireConfigSchema.parse(config);
  } catch (e) {
    const error = resolveError(e);

    throw new Error(
      `[parseQuestionnaireConfig] Questionnaire '${questionnaireName}' is invalid. ${error.message}`
    );
  }
}

/**
 * CGS questionnaire/inventory
 */
export const CgsQuestionnaire = parseQuestionnaireConfigSchema('cgs', {
  id: 'cgs',
  subsections: { cgs: CgsJson as any }
});

/**
 * DHI questionnaire/inventory
 */
export const DhiQuestionnaire = parseQuestionnaireConfigSchema('dhi', {
  id: 'dhi',
  subsections: { dhi: dhiJson as any }
});

/**
 * PCS questionnaire/inventory
 */
export const PcsQuestionnaire = parseQuestionnaireConfigSchema('pcs', {
  id: 'pcs',
  subsections: { pcs: pcsJson as any }
});

export const PromisQuestionnaire = parseQuestionnaireConfigSchema(
  'promis',
  promisJson as any
);
